import { render, staticRenderFns } from "./UpgradeIconSvg.vue?vue&type=template&id=0b9b468d"
import script from "./UpgradeIconSvg.vue?vue&type=script&lang=js"
export * from "./UpgradeIconSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports